module.exports = __webpack_public_path__ + "media/images/result_sets/circles/5n4n8r7n-308d37a98402fecc8fc2d285b985b28e.svg";